var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTriangle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.108,
    height: 13.94,
    viewBox: "0 0 28.108 13.94",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M6067,1909.061a10,10,0,0,1,8.676,5.027l3.959,6.907a2,2,0,0,0,3.541-.135l2.9-6.1a10,10,0,0,1,9.028-5.7",
    transform: "translate(-6067 -1908.561)",
    fill: "rgba(0,0,0,0.8)",
    stroke: "rgba(255,255,255,0.1)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTriangle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/triangle.09d90b67.svg";
export { ForwardRef as ReactComponent };